module.exports = __webpack_public_path__ + "static/img/bottom-button-3.38e2e96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/report/bottom-button-3.png
// module id = NcvB
// module chunks = 1